import React from 'react';
import * as R from 'ramda';
import moment from 'moment';
import { connect } from 'react-redux';

import { fetchProjects } from '../../services/Api';

const PROJECT_TYPES = {
  POSITION: {
    label: 'Position'
  },
  GROUP_ASSESSMENT: {
    label: 'Group assessment'
  },
  TALENT_PROGRAM: {
    label: 'Talent program'
  },
  VIEW: {
    label: 'View'
  },
  QUESTIONNAIRE: {
    label: 'Questionnaire'
  }
};

class CompanyItemProjectsList extends React.Component {
  state = {
    expanded: false,
    loaded: false,
    loading: false,
    projects: []
  };

  loadProjects = () => {
    const {
      company: { id },
      auth: { access_token }
    } = this.props;
    this.setState({ loading: true });
    fetchProjects(id, access_token)
      .then(res => {
        this.setState({ loaded: true, projects: res.body.items });
      })
      .finally(() => this.setState({ loading: false }));
  };

  handleToggleExpanded = e => {
    e.preventDefault();
    const { expanded, loaded } = this.state;
    if (!loaded && !expanded) {
      this.loadProjects();
    }
    this.setState({ expanded: !expanded });
  };

  render() {
    const { expanded, loaded, loading, projects } = this.state;
    if (loading) {
      return (
        <div className="row" style={{ padding: '0' }}>
          <div className="col-sm-12">
            <small className="font-weight-light">Loading...</small>
          </div>
        </div>
      );
    }
    return (
      <div>
        {loaded && projects.length === 0 ? (
          <div className="row" style={{ padding: '0' }}>
            <div className="col-sm-12">
              <small className="font-weight-light">No projects</small>
            </div>
          </div>
        ) : (
          <div className="row" style={{ padding: '0' }}>
            <div className="col-sm-12">
              <small>
                <a role="button" onClick={this.handleToggleExpanded}>
                  {expanded ? 'Collapse' : 'Expand projects'}
                </a>
              </small>
            </div>
          </div>
        )}
        {expanded &&
          R.map(
            p => (
              <div key={p.id} className="row" style={{ padding: '0' }}>
                <div className="col-sm-7">
                  <small>
                    <strong>{p.name} </strong>
                    <span className="font-weight-light" style={{ fontFamily: 'monospace' }}>
                      {' '}
                      ({p.slug}){' '}
                    </span>
                    <span className="badge badge-pill badge-dark">{PROJECT_TYPES[p.projectType].label}</span>
                    {R.map(
                      lang => (
                        <span key={lang} className="badge badge-pill badge-secondary" style={{ marginLeft: '4px' }}>
                          {lang.toUpperCase()}
                        </span>
                      ),
                      p.languages
                    )}
                  </small>
                </div>
                <div className="col-sm-5">
                  <small className="font-weight-light">
                    Created at: <strong>{moment(p.createdAt).format('L LT')}</strong>
                  </small>
                  <small className="font-weight-light">&nbsp; | &nbsp;</small>
                  {p.validTo ? (
                    <small className="font-weight-light" style={p.validTo < Date.now() ? { color: 'red' } : {}}>
                      Valid to: <strong>{moment(p.validTo).format('L LT')}</strong>
                    </small>
                  ) : (
                    <small className="font-weight-light">Valid indefinitely</small>
                  )}
                </div>
                {/*<div className="col-sm-4">*/}
                {/*  <small className="font-weight-light">*/}
                {/*    Total profiles: <strong>{p.activity.statusCounts.total}</strong>*/}
                {/*  </small>*/}
                {/*  <small className="font-weight-light">&nbsp; | &nbsp;</small>*/}
                {/*  <small className="font-weight-light">*/}
                {/*    Finished: <strong>{p.activity.statusCounts.finished}</strong>*/}
                {/*  </small>*/}
                {/*  <small className="font-weight-light">&nbsp; | &nbsp;</small>*/}
                {/*  <small className="font-weight-light">*/}
                {/*    Started: <strong>{p.activity.statusCounts.started}</strong>*/}
                {/*  </small>*/}
                {/*</div>*/}
              </div>
            ),
            projects
          )}
      </div>
    );
  }
}

const mapStateToProps = state => ({ auth: state.auth });

export default connect(mapStateToProps)(CompanyItemProjectsList);



// WEBPACK FOOTER //
// ./src/containers/private/CompanyItemProjectsList.js